import type { User } from 'common/interfaces';
import type { MainMenuItem, SubMenuItem } from 'components/side-menu/side-menu-interfaces';

type MenuItem = Partial<Pick<MainMenuItem, 'roles' | 'links' | 'subMenuItems'> & Pick<SubMenuItem, 'external'>>;

export const fillMenuItemsWithRoles = <TMenuItem extends MenuItem>(menuItems: TMenuItem[], user: User) => {
  return menuItems.map(menuItem => {
    const newMenuItem = { ...menuItem };

    if (newMenuItem.roles && newMenuItem.links) {
      const filteredLinks = newMenuItem.links.filter(link =>
        [...user.appPages, ...user.customPages, { url: user.schadenmeldenLink }].some(page => page.url === link)
      );

      const hasValidLinks = filteredLinks.length > 0;
      newMenuItem.roles = hasValidLinks ? [user.mainRole] : [];
      newMenuItem.links = filteredLinks;
    }

    if (newMenuItem.subMenuItems) {
      newMenuItem.subMenuItems = fillMenuItemsWithRoles(newMenuItem.subMenuItems, user);
    }

    return newMenuItem;
  });
};
